import React from "react";

import { useTranslate } from "localization";
import { Filter } from "ui/forms";

import { useTimePeriodsQuery } from "API";

import useFilterParam from "./useFilterParam";

interface TimePeriodProps {
  submissionGroupId: string;
}

const TimePeriod: React.FC<TimePeriodProps> = ({ submissionGroupId }) => {
  const { translate } = useTranslate();
  const title = translate("timePeriod");

  const {
    data = [],
    isSuccess,
    isError,
  } = useTimePeriodsQuery(submissionGroupId);
  const [selected, setSelected] = useFilterParam("timePeriod", data, {
    defaultToFirst: false,
    ready: isSuccess || isError,
  });
  const selectedLabel = data.find((o) => o.value === selected)?.label ?? title;
  return (
    <Filter
      items={{ options: data }}
      title={title}
      label={selectedLabel}
      onChange={setSelected}
      selected={!!selected}
      disabled={!isSuccess}
      value={selected ?? ""}
      showReset={true}
      showApply={true}
      searchable={true}
      translate={translate}
    />
  );
};

export default TimePeriod;
